// extracted by mini-css-extract-plugin
export default {"button":"Pl-z","reviewSort":"Ql-z"};